import { configureDayjs } from '#helpers';
import {
  dateToCustomDate,
  type DatePeriod,
  type DateSelectionOption,
  type FiltersStateType,
  type ProductTaxonomyType,
  type ReferentialIntervalsType
} from '@carrefour-gcs/shared';
import dayjs from 'dayjs';

configureDayjs();

export const FILTERS_STATE_DEFAULT_VALUES: FiltersStateType = {
  nomenclatureFilters: [],
  activityTypesFilters: [],
  storesFilters: [],
  integratedFranchisedFilters: [],
  triptyqueFilters: [],
  suppliersFilters: [],
  brandsFilters: [],
  bemHoldingFilters: [],
  bemMerchandiseFilters: [],
  itemFilters: [],
  barcodeFilters: [],
  storesRegionFilters: [],
  assortmentTypologyFilters: [],
  productTypologyFilters: [],
  competitorFilters: [],
  competitorBaseBarcodeFilters: [],
  competitorBaseItemFilters: [],
  competitorComparisonBarcodeFilters: [],
  competitorComparisonItemFilters: [],
  competitorBrandsFilters: [],
  consostyleMicroFilters: [],
  lifestageMicroFilters: [],
  businessBrandFilters: [],
  businessBrandReducedFilters: []
};

export const EMPTY_FILTERS_STATE: FiltersStateType = {
  nomenclatureFilters: [],
  activityTypesFilters: [],
  storesFilters: [],
  integratedFranchisedFilters: [],
  triptyqueFilters: [],
  suppliersFilters: [],
  brandsFilters: [],
  bemHoldingFilters: [],
  bemMerchandiseFilters: [],
  itemFilters: [],
  barcodeFilters: [],
  storesRegionFilters: [],
  assortmentTypologyFilters: [],
  productTypologyFilters: [],
  competitorFilters: [],
  competitorBaseBarcodeFilters: [],
  competitorBaseItemFilters: [],
  competitorComparisonBarcodeFilters: [],
  competitorComparisonItemFilters: [],
  competitorBrandsFilters: [],
  consostyleMicroFilters: [],
  lifestageMicroFilters: [],
  businessBrandFilters: [],
  businessBrandReducedFilters: []
};

export const DEFAULT_PERIOD_INTERVAL = {
  start: {
    year: dayjs().year(),
    month: dayjs().month() + 1,
    day: dayjs().date()
  },
  end: {
    year: dayjs().year(),
    month: dayjs().month() + 1,
    day: dayjs().date()
  }
};

export const DEFAULT_PERIOD_OPTIONS: DateSelectionOption = 'year_to_date';

export const DEFAULT_PERIOD_PERIOD: DatePeriod = 'monthly';

export const DEFAULT_TAXONOMY: ProductTaxonomyType = 'carrefour';

export const DEFAULT_IS_WITH_TAX: boolean = false;

export const DEFAULT_PERIOD_REFERENTIAL_INTERVALS: ReferentialIntervalsType = {
  carrefour: {
    standard: {
      daily: {
        start: { year: 2004, month: 1, day: 28 },
        end: dateToCustomDate(dayjs().add(1, 'day').toDate())
      },

      weekly: {
        start: { year: 2004, month: 1, day: 28 },
        end: dateToCustomDate(
          dayjs()
            .isoWeek(dayjs().isoWeek() - 1)
            .isoWeekday(7)
            .toDate()
        )
      },
      monthly: {
        start: { year: 2004, month: 1, day: 28 },
        end: dateToCustomDate(dayjs().endOf('month').toDate())
      }
    }
  }
};
